import "core-js/modules/es.array.push.js";
import auth from "../../assets/imgs/icon/icon8.png";
import activeauth from "../../assets/imgs/icon/icon17.png";
import car from "../../assets/imgs/icon/icon5.png";
import activecar from "../../assets/imgs/icon/icon10.png";
import invoice from "../../assets/imgs/icon/icon7.png";
import activeinvoice from "../../assets/imgs/icon/icon13.png";
import order from "../../assets/imgs/icon/icon6.png";
import activeorder from "../../assets/imgs/icon/icon11.png";
import home from "../../assets/imgs/icon/icon4.png";
import activehome from "../../assets/imgs/icon/icon9.png";
import clipboard3 from "vue-clipboard3";
import { reactive, onMounted, getCurrentInstance, onBeforeUnmount } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useMainStore } from "../../pinia/main";
import { phoneDesc, isPhoneNumber, EncryptName } from "../../util/index";
import { ElMessage, ElMessageBox } from "element-plus";
import { AuthTypeMap } from "@/util/type";
import baseinfo from "../../assets/imgs/icon/icon.png";
import activebaseinfo from "../../assets/imgs/icon/icon18.png";
import accountsafe from "../../assets/imgs/icon/icon1.png";
import activeaccountsafe from "../../assets/imgs/icon/icon19.png";
import privacy from "../../assets/imgs/icon/icon2.png";
import activeprivacy from "../../assets/imgs/icon/icon20.png";
import contract from "../../assets/imgs/icon/icon3.png";
import activecontract from "../../assets/imgs/icon/icon21.png";
import phone from "../../assets/imgs/icon/icon28.png";
import activephone from "../../assets/imgs/icon/icon27.png";
import zhCn from "element-plus/es/locale/lang/zh-cn";
export default {
  name: "Layout",
  props: {},
  setup() {
    const {
      toClipboard
    } = clipboard3();
    const router = useRouter();
    const mainStore = useMainStore();
    const internal = getCurrentInstance();
    const globalProperties = internal?.appContext.config.globalProperties;
    let data = reactive({
      isExpend: false,
      menuBar: [{
        name: "系统首页",
        path: "/layout/home",
        default: home,
        active: activehome,
        dot: false
      }, {
        name: "发货管理",
        path: "/layout/shipments",
        default: car,
        active: activecar,
        dot: false
      }, {
        name: "订单管理",
        path: "/layout/order",
        default: order,
        active: activeorder,
        dot: false
      }, {
        name: "结算管理",
        path: "/layout/invoice",
        default: invoice,
        active: activeinvoice,
        dot: false
      }, {
        name: "认证管理",
        path: "/layout/auth",
        default: auth,
        active: activeauth,
        dot: false
      }],
      personListIndex: -1,
      personList: [{
        label: "基础信息",
        default: baseinfo,
        active: activebaseinfo,
        src: "/layout/personalinformation"
      }, {
        label: "账户安全",
        default: accountsafe,
        active: activeaccountsafe,
        src: "/layout/accountsecurity"
      }, {
        label: "隐私政策",
        default: privacy,
        active: activeprivacy,
        src: "/layout/privacypolicy"
      }, {
        label: "我的合同",
        default: contract,
        active: activecontract,
        src: "/layout/mycontract"
      }, {
        label: "联系客服",
        default: phone,
        active: activephone,
        src: "/layout/servicephone"
      }],
      identityAuth: -1,
      //身份证是否认证 -1 3->未提交 0->提交 1->通过 2->拒绝
      companyAuth: -1,
      //企业是否认证 -1  3->未提交 0->提交 1->通过 2->拒绝
      servicePhoneList: [],
      isViewStartUp: true,
      startUpTimer: null,
      countdown: 1
    });
    onMounted(() => {
      startStartUpTimer();
      selectCustomerAuth();
    });
    // 组件销毁前自动清除定时器
    onBeforeUnmount(() => {
      stopStartUpTimer();
    });
    const stopStartUpTimer = () => {
      if (data.startUpTimer) {
        clearInterval(data.startUpTimer);
        data.startUpTimer = null;
      }
    };
    const startStartUpTimer = () => {
      // 先清除已有的定时器
      stopStartUpTimer();
      data.startUpTimer = setInterval(() => {
        if (data.countdown > 0) {
          data.countdown--;
        } else {
          data.isViewStartUp = false;
          stopStartUpTimer();
        }
      }, 1000);
    };

    //退出登陆
    const logout = () => {
      ElMessageBox.confirm("您确定退出登录吗？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        showClose: false
      }).then(async () => {
        var res = await globalProperties.$api.logout();
        if (res) {
          ElMessage({
            type: "success",
            message: "登出成功"
          });
          await mainStore.setUserInfo(null);
          await mainStore.setTabIndex("0");
          router.push("/");
        }
      }).catch(() => {});
    };

    //获取认证信息
    const selectCustomerAuth = async () => {
      var {
        identityAuth,
        companyAuth
      } = await globalProperties.$api.selectCustomerAuth();
      data.identityAuth = identityAuth;
      data.companyAuth = companyAuth;
    };

    //切换页面
    const handlesSelectMenu = index => {
      data.personListIndex = -1;
      // if (index == mainStore.tabIndex) return;
      mainStore.setTabIndex(index);
      router.replace(data.menuBar[Number(index)].path);
      selectCustomerAuth();
    };

    //去目标页面
    const toTargetPage = path => router.push({
      path
    });
    const setIsExpend = () => {
      data.isExpend = !data.isExpend;
    };
    const setPersonListIndex = (index, path) => {
      data.personListIndex = index;
      mainStore.setTabIndex(-1);
      router.push({
        path
      });
    };
    return {
      setPersonListIndex,
      setIsExpend,
      data,
      mainStore,
      handlesSelectMenu,
      phoneDesc,
      logout,
      toTargetPage,
      isPhoneNumber,
      EncryptName,
      AuthTypeMap,
      zhCn
    };
  }
};